import { Box, Heading, Text } from 'ui'
import { InfoLineItem } from './InfoLineItem'
import { CarIcon, VerifiedIcon } from 'lucide-react'
import { useWorkerProfileContext } from '../context/WorkerProfileProvider'

export function Certifications() {
  const { state: profile } = useWorkerProfileContext()

  return (
    <Box width={1} py={3}>
      <Heading level={4}>Certifications & Qualifications</Heading>
      {profile.worker.backgroundCheckStatus === 'clear' ? (
        <InfoLineItem
          icon={<VerifiedIcon size={20} />}
          label={'Background Check'}
          value={<Text color={'neutrals.200'}>Verified</Text>}
        />
      ) : null}
      {profile.worker.workProfile?.hasLicense ? (
        <InfoLineItem
          icon={<VerifiedIcon size={20} />}
          label={'Valid Drivers License'}
          value={<Text color={'neutrals.200'}>Verified</Text>}
        />
      ) : null}
      {profile.worker.workProfile?.hasCar ? (
        <InfoLineItem
          icon={<CarIcon size={20} />}
          label={'Drives Personal Vehicle'}
          value={<Text color={'neutrals.200'}>&nbsp;</Text>}
        />
      ) : null}
    </Box>
  )
}
